/*
 * @Description: 公共方法
 * @Date: 2024-12-23 09:59:27
 */
import { storeToRefs } from 'pinia';
import _ from 'lodash';
import appStore from '@/store';
import { storage } from '@/utils/storage';

/**
 * @description: 不需要处理的数据
 * @param {*} item
 * @returns {*}
 */
export const isSkip = item => {
  return (
    item.label === '操作' ||
    ['handle'].includes(item.prop) ||
    ['_selection', 'expand', 'index'].includes(item.type)
  );
};

/**
 * @description: 设置表格字段、搜索字段
 * @returns {*}
 */
export const useSetTableConfig: ({
  storeKey,
  checkedKeys, // 勾选数据
  tableColumns, // 列表数据
  searchColumns // 搜索数据
}: {
  storeKey?: string; // 缓存标识
  checkedKeys?: Array<{ prop: string; _sort: number }>; // 勾选数据
  tableColumns: any[]; // 列表数据
  searchColumns: any[]; // 搜索数据
}) => {
  newTableColumns;
  newSearchColumns;
} = ({ checkedKeys, tableColumns, searchColumns, storeKey }) => {
  if (storeKey) checkedKeys = storage.get(getColumnsCheckedKey(storeKey));

  const newTableColumns = _.cloneDeep(tableColumns)
    .filter(current => {
      if (isSkip(current) || current._disabled) return true;
      if (!checkedKeys) return current._checked;

      const obj = checkedKeys.find(val => val.prop === current.prop);
      if (obj) {
        current._checked = 1;
        current._sort = obj._sort;
        return true;
      }

      return false;
    })
    .sort((a, b) => a._sort - b._sort);

  const newSearchColumns = _.cloneDeep(searchColumns)
    .filter(item => {
      const column = newTableColumns.find(val => {
        return [val?.label, ...(val?._relevance || [])].includes(item.label);
      });
      if (column) {
        item._sort = column._sort;
        return true;
      }

      return false;
    })
    .sort((a, b) => a._sort - b._sort);

  return {
    newTableColumns,
    newSearchColumns
  };
};

/**
 * @description: 获取缓存key
 * @param {*} name
 * @returns {*}
 */
export const getColumnsCheckedKey = (name = 'project') => {
  const { info, defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
  return `${info.value.phone}_${defaultUserFnCode.value}_${name}_retain`;
};
